import { Timestamp } from "firebase/firestore";
import type { RepairTruck, TransportTruckStatus } from "../logistics/logistics";
//test comment
export interface RepairUser {
    id: string;
    name: string;
    email: string;
    phone: string;
    /** Primary / legacy shop id; matches first entry in `shop_ids` when present */
    shop_id: string;
    /** All repair shops this user can access */
    shop_ids?: string[];
    createdAt: Timestamp;
    updatedAt: Date;
}

export type InspectionChecklistAnswerOption = "yes" | "no" | "na";

export interface InspectionChecklistQuestion {
    id: string;
    question: string;
    enabled: boolean;
    allowNotes: boolean;
    order: number;
    answerOptions: InspectionChecklistAnswerOption[];
}

export interface InspectionChecklist {
    id: string;
    name: string;
    /** Distinguishes Intake vs Complete templates when set on a per-shop checklist. */
    kind?: "intake" | "complete";
    questions: InspectionChecklistQuestion[];
    createdAt?: Timestamp;
    updatedAt?: Timestamp;
}

export const ACTIVE_REPAIR_TRUCK_STATUSES: TransportTruckStatus[] = [
    "repair",
    "awaiting_transport",
];

export function isActiveRepairTruckStatus(
    status: TransportTruckStatus | string | null | undefined
): status is TransportTruckStatus {
    return !!status && ACTIVE_REPAIR_TRUCK_STATUSES.includes(status as TransportTruckStatus);
}

export function isTruckActiveAtRepairShop(params: {
    truckStatus: TransportTruckStatus | string | null | undefined;
    currentLocationId?: string | null;
    repairShopLocationId?: string | null;
}): boolean {
    const { truckStatus, currentLocationId, repairShopLocationId } = params;
    if (!isActiveRepairTruckStatus(truckStatus)) return false;
    if (!currentLocationId || !repairShopLocationId) return false;
    return currentLocationId === repairShopLocationId;
}

/** Storage paths of pre-repair damage photos recorded on a repair visit. */
export function getDamagePhotoStoragePaths(
    repairTruck: RepairTruck | undefined | null
): string[] {
    if (!repairTruck?.work_notes) return [];
    return repairTruck.work_notes
        .filter(
            (note) =>
                note.media?.type === "damage_photo" &&
                Boolean(note.media.storage_path)
        )
        .map((note) => note.media!.storage_path);
}

export function countDamagePhotos(repairTruck: RepairTruck | undefined | null): number {
    return getDamagePhotoStoragePaths(repairTruck).length;
}